import { Vector3 } from 'three';
import { PLAYER } from '../config/settings';

/**
 * Pure kinematic state of the player. No behaviour lives here — systems
 * (controller, collider, camera) read and mutate these fields. Keeping the
 * data in one small object makes the simulation easy to inspect and test.
 */
export class Player {
  readonly position = PLAYER.SPAWN.clone();
  readonly velocity = new Vector3();

  /** Look angles (radians). */
  yaw = Math.PI;
  pitch = -0.05;

  readonly eyeHeight = PLAYER.EYE_HEIGHT;
  readonly radius = PLAYER.RADIUS;
  readonly height = PLAYER.HEIGHT;

  // --- set every frame by the collider ---
  grounded = false;
  touchingWall = false;
  readonly wallNormal = new Vector3(); // outward horizontal normal of touched wall
  wallTopY = 0; // roof height of the touched building (for mantling)

  // --- movement-state bookkeeping ---
  climbRelockTimer = 0; // seconds during which wall-cling is disabled (after a leap)

  /** World-space eye position, written into `out`. */
  eyePosition(out: Vector3): Vector3 {
    return out.copy(this.position).setY(this.position.y + this.eyeHeight);
  }

  get horizontalSpeed(): number {
    return Math.hypot(this.velocity.x, this.velocity.z);
  }
}
